import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocaleState } from '../..';
export const LocaleListener = ({ translators, children }) => {
    const { language } = useLocaleState();
    const [currentLanguage, setCurrentLanguage] = useState(language); // Forces re-renders
    useEffect(() => {
        translators.forEach((translator) => translator.setLanguage && translator.setLanguage(language));
        setCurrentLanguage(language);
    }, [language]);
    return React.createElement("div", { key: currentLanguage }, children);
};
LocaleListener.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    translators: PropTypes.array.isRequired,
    children: PropTypes.node,
};
LocaleListener.defaultProps = {
    children: null,
};
